import React from "react";
import Navbar1Combine from "./Header/Navbar1Combine";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router} from "react-router-dom";
import { Container, Row, Col} from "react-bootstrap";
import Footer from "./Footer/footer";
import banner1 from "./images/sikkimimages/banner.png";
import { Helmet } from "react-helmet";
class TermsCondition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Tabcontent: "Inclusions",
    };
  }

  render() {
    return (
      <Container fluid className="p-0 m-0">
        {/* meta tags----------------------- */}
        <Helmet>
          <meta name="title" content="Terms & Conditions" />
          <meta
            name="description"
            content="Holxo offers holistic and customized holidays, specially curated by our travel experts with the best combination of handpicked hotels"
          />
          <meta
            name="keywords"
            content="india travel, travel in india, tours, travel, holistic and customized holidays, packages, holidays, holiday packages in India, tour packages, vacation packages, holidays in India, india tourism, holiday destinations, holiday packages, holiday packages india, india tours, india honeymoon package, honeymoon packages, india tour packages, Indian holidays, cheap holiday packages"
          />
          <meta name="robots" content="index, follow" />
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <meta name="language" content="English" />

          {/* og tags------------------------ */}

          <meta property="og:title" content="Terms & Conditions" />
          <meta property="og:site_name" content="Holxo" />
          <meta
            property="og:url"
            content="https://holexo.com/termsandconditions"
          />
          <meta
            property="og:description"
            content="Holxo offers holistic and customized holidays, specially curated by our travel experts with the best combination of handpicked hotels"
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:image"
            content="https://holexo.com/static/media/banner.77113d1c5d6b915e2fc7.png"
          />
        </Helmet>

        <Router>
          <Navbar1Combine />
          <div className="p-0 m-0 aboutuscommonbannerall">
            <img
              src={banner1}
              className="forwebsite"
              alt=""
              style={{ width: "100%" }}
            ></img>
            <img src={banner1} alt="" className="aboutwidth formobile"></img>
          </div>
          <Container className="destinationcard">
            <h1 className="sectionheading">Terms & Conditions</h1>
            <div className="geeks"></div>
            <h5 className="termphnfont">
              Before you sail off on your travel journeys with us, understand
              the terms and conditions from our team.
            </h5>

            <Row>
              <Col x lg="12" className="termsconditionmaindivfont">
                <p
                  style={{
                    textAlign: "justify",
                    fontFamily: "AvenirNext-UltraLight",
                    fontWeight: "600",
                    lineHeight: "32px",
                  }}
                >
                  Contact our team at{" "}
                  <a
                    className="numberPolicytext"
                    href="tel:9873998300"
                    style={{ color: "black" }}
                  >
                    +91-98739 98300
                  </a>{" "}
                  to know more about our terms & conditions.{" "}
                </p>
                <p
                  style={{
                    fontFamily: "AvenirNext-UltraLight",
                    fontWeight: "600",
                    lineHeight: "32px",
                  }}
                >
                  Or write to us at : <br />
                  <a
                    className="numberPolicytext"
                    href="mailto:varun@holxoholidays.com"
                    style={{ color: "black" }}
                  >
                    mitali@holxoholidays.com
                  </a>
                </p>
              </Col>
            </Row>
          </Container>
          <Footer style={{ margin: "0rem auto auto auto" }} />
        </Router>
      </Container>
    );
  }
}

export default TermsCondition;
